type UPQRequiredFieldValidation = {
    field: 'sellRate' | 'residual' | 'balloonPayment';
    isMissing: boolean;
};

export const getMissingFieldDisplayNames = (missingFields: UPQRequiredFieldValidation[]): string[] => {
    return missingFields.map((f) => {
        if (f.field === 'sellRate') return 'Sell Rate';
        if (f.field === 'residual') return 'Residual';
        if (f.field === 'balloonPayment') return 'Balloon Payment';
        return f.field;
    });
};

export const getUPQMissingFieldsMessage = (missingFields: UPQRequiredFieldValidation[]): string => {
    const missingFieldNames = getMissingFieldDisplayNames(missingFields);
    return `Missing required field(s): ${missingFieldNames.join(', ')}.`;
};
